{
  "buttons": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "continue": "Fortfahren",
    "back": "Zurück",
    "submit": "Absenden",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "next": "Weiter",
    "previous": "Zurück",
    "upload": "Hochladen",
    "download": "Herunterladen",
    "refresh": "Aktualisieren",
    "retry": "Erneut versuchen",
    "learnMore": "Mehr erfahren",
    "getStarted": "Loslegen",
    "viewDetails": "Details anzeigen",
    "saveChanges": "Änderungen speichern"
  },
  "labels": {
    "email": "E-Mail",
    "name": "Name",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "phone": "Telefon",
    "company": "Unternehmen",
    "companyName": "Firmenname",
    "country": "Land",
    "address": "Adresse",
    "city": "Stadt",
    "state": "Bundesland",
    "postcode": "Postleitzahl",
    "website": "Webseite",
    "description": "Beschreibung",
    "date": "Datum",
    "status": "Status",
    "actions": "Aktionen",
    "type": "Typ",
    "category": "Kategorie",
    "notes": "Notizen"
  },
  "status": {
    "loading": "Laden...",
    "saving": "Speichern...",
    "success": "Erfolgreich!",
    "error": "Ein Fehler ist aufgetreten",
    "pending": "Ausstehend",
    "completed": "Abgeschlossen",
    "inProgress": "In Bearbeitung",
    "draft": "Entwurf",
    "active": "Aktiv",
    "inactive": "Inaktiv"
  },
  "validation": {
    "required": "Dieses Feld ist erforderlich",
    "invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "minLength": "Muss mindestens {{min}} Zeichen haben",
    "maxLength": "Darf nicht mehr als {{max}} Zeichen haben",
    "invalidPhone": "Bitte geben Sie eine gültige Telefonnummer ein",
    "invalidUrl": "Bitte geben Sie eine gültige URL ein"
  },
  "errors": {
    "generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "network": "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
    "unauthorized": "Sie sind nicht berechtigt, diese Aktion durchzuführen.",
    "notFound": "Die angeforderte Ressource wurde nicht gefunden.",
    "serverError": "Serverfehler. Bitte versuchen Sie es später erneut."
  },
  "navigation": {
    "home": "Startseite",
    "dashboard": "Dashboard",
    "settings": "Einstellungen",
    "profile": "Profil",
    "logout": "Abmelden",
    "login": "Anmelden",
    "signUp": "Registrieren",
    "help": "Hilfe",
    "support": "Support"
  },
  "time": {
    "today": "Heute",
    "yesterday": "Gestern",
    "lastWeek": "Letzte Woche",
    "lastMonth": "Letzter Monat",
    "ago": "vor",
    "minutes": "Minuten",
    "hours": "Stunden",
    "days": "Tagen"
  },
  "language": {
    "select": "Sprache auswählen",
    "en": "English",
    "es": "Español",
    "de": "Deutsch",
    "zh": "中文"
  }
}
